/** Adding, editing and deleting clients. */

import { apiCall, orgPath } from '../api.ts';
import type { Client } from '../reports/reports-api.ts';

export interface ClientInput {
  name?: string;
  website?: string | null;
  timezone?: string | null;
}

const clients = (org: string, path = '') => orgPath(org, `/reports/clients${path}`);

export const clientsApi = {
  list: (org: string) => apiCall<{ clients: Client[] }>(clients(org)).then((data) => data.clients),
  create: (org: string, input: ClientInput) =>
    apiCall<{ client: Client }>(clients(org), { method: 'POST', body: JSON.stringify(input) }).then(
      (data) => data.client,
    ),
  update: (org: string, id: string, input: ClientInput) =>
    apiCall<{ client: Client }>(clients(org, `/${id}`), {
      method: 'PATCH',
      body: JSON.stringify(input),
    }).then((data) => data.client),
  remove: (org: string, id: string) =>
    apiCall<unknown>(clients(org, `/${id}`), { method: 'DELETE' }),
};
